import { render, staticRenderFns } from "./ProductName.vue?vue&type=template&id=527f3bb5&functional=true"
import script from "./ProductName.vue?vue&type=script&lang=js"
export * from "./ProductName.vue?vue&type=script&lang=js"
import style0 from "./ProductName.vue?vue&type=style&index=0&id=527f3bb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports